import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=3a40f17e&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PC.vue?vue&type=style&index=1&id=3a40f17e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40f17e",
  null
  
)

export default component.exports